import LoadingSpin from "components/Loading spins/LoadingSpin";
import AntDInputField from "./AntDInputField";
import { useState } from "react";
import { Form } from "antd";
import UserProfileService from "services/UserProfileService";
import { toast } from "react-toastify";

function ChangePassword() {
  const [loadingSpin, setLoadingSpin] = useState<boolean>(false);
  const [form] = Form.useForm();
  const [errors, setErrors] = useState({
    current_password: "",
    new_password: "",
  });

  const onSubmit = async () => {
    setLoadingSpin(true);
    const formData = form.getFieldsValue();
    const user: any = localStorage.getItem("persist:root");
    const data = JSON.parse(JSON.parse(user).user);
    setErrors({ current_password: "", new_password: "" });
    await UserProfileService.changePassword(
      data.currentUser.access_token,
      formData
    )
      .then((res) => {
        setLoadingSpin(false);
        if (res.status === 200) {
          toast.success("Password successfully changed!");
          form.setFieldsValue({
            current_password: "",
            new_password: "",
            new_password_confirmation: "",
          });
        } else {
          toast.error("There is an issue when changing password!");
        }
      })
      .catch((e: any) => {
        setLoadingSpin(false);
        if (e.response && e.response.status === 422) {
          let errorData = "";
          if (e?.response?.data?.errors?.current_password) {
            errorData = e?.response?.data?.errors?.current_password[0];
            setErrors({ ...errors, current_password: errorData });
          } else {
            errorData = e?.response?.data?.errors?.new_password[0];
            setErrors({ ...errors, new_password: errorData });
          }
          toast.warning(errorData);
        } else {
          toast.error("An error occurred. Please try again.");
        }
      });
  };

  return (
    <div className="mb-6 w-full px-4 max-sm:px-3">
      <div className="mt-5 grid grid-cols-1 gap-6 lg:grid-cols-3">
        {/* MAIN form (2/3) */}
        <div className="rounded-2xl p-6 lg:col-span-2 max-sm:p-4">
          <h1 className="text-[25px] font-bold text-white max-sm:text-[22px]">
            Change Password
          </h1>
          <p className="mb-4 mt-1 text-sm text-white/50">
            Use a strong password you don't use elsewhere.
          </p>

          <Form form={form} layout="vertical">
            <div className="w-full">
              <span className="text-[15px] text-white">Current Password</span>
              <AntDInputField
                name="current_password"
                type="password"
                placeholder="Current Password"
                rules={[
                  {
                    required: true,
                    message: "Please enter your current password!",
                  },
                ]}
                password={true}
              />
              {errors?.current_password ? (
                <p className="red-text">{errors?.current_password}</p>
              ) : (
                <></>
              )}
            </div>

            <div className="grid grid-cols-2 gap-x-6 max-sm:grid-cols-1">
              <div>
                <span className="text-[15px] text-white">New Password</span>
                <AntDInputField
                  name="new_password"
                  type="password"
                  placeholder="New Password"
                  rules={[
                    {
                      required: true,
                      message: "Please confirm your password!",
                    },
                  ]}
                  password={true}
                />
              </div>

              <div>
                <span className="text-[15px] text-white">
                  Confirm New Password
                </span>
                <AntDInputField
                  name="new_password_confirmation"
                  type="password"
                  placeholder="Confirm New Password"
                  rules={[
                    {
                      required: true,
                      message: "Please confirm your password!",
                    },
                    ({ getFieldValue }: any) => ({
                      validator(_: any, value: any) {
                        if (!value || getFieldValue("new_password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error("Incorrect password. Please try again.")
                        );
                      },
                    }),
                  ]}
                  password={true}
                />
              </div>
            </div>

            <button
              className="button-red mt-4 min-w-[130px] rounded-full px-4 py-2 text-white transition-opacity hover:opacity-90 max-sm:w-full"
              type="submit"
              onClick={onSubmit}
            >
              {loadingSpin ? (
                <LoadingSpin fontSize={20} color={"white"} />
              ) : (
                `Change Password`
              )}
            </button>
          </Form>
        </div>

        {/* SIDE info (1/3) */}
        <div className="space-y-6 lg:col-span-1">
          <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-6">
            <p className="mb-3 text-xs font-semibold uppercase tracking-[0.15em] text-white/40">
              Password tips
            </p>
            <ul className="space-y-2 text-sm text-white/60">
              <li>Use at least 8 characters.</li>
              <li>Mix uppercase, lowercase, numbers & symbols.</li>
              <li>Avoid reusing passwords from other sites.</li>
              <li>Don't share your password with anyone.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChangePassword;